import type {
    ApiEcConfig,
    ApiHomePageConfig,
    ApiMallConfig,
    ApiProductsClassificationConfig,
} from '@/types/config/api-config.types';

/**
 * 內部 API 常數
 */
export const API_HOME_PAGE: ApiHomePageConfig = {
    PRODUCT_THEME_LIST: '/product/get-product-theme-list-by-type',
    HOME_PRODUCT_LIST: '/product/get-home-product-list',
    NEWS_LIST: '/announcement/get-news-list',
};

/**
 * 產品分類 API 常數
 */
export const API_PRODUCTS_CLASSIFICATION: ApiProductsClassificationConfig = {
    PRODUCT_MAIN_CLASS_TREE:
        '/product/get-product-main-class-tree-by-super-class-id',
    PRODUCT_MAIN_CLASS_DETAIL: '/product/get-product-list-by-main-class-id',
    PRODUCT_POSTPROCESSING_DETAIL:
        '/product/get-postprocessing-product-list-by-main-class-id',
};

/**
 * EC API 常數
 */
export const API_EC: ApiEcConfig = {
    LOGIN: '/member/login',
    LOGOUT: '/member/logout',
    REFRESH_TOKEN: '/Account/RefreshToken',
    GET_MEMBER_INFO: '/member/get-member-info',
    GET_CHECKOUT_MEMBER: '/Service/GetMember',
    GET_STORED_AMOUNT: '/Service/GetStoredAmount',
    CHECK_IS_TAX: '/Service/CheckIsTax',
    GET_COMPANY: '/Service/GetCompany',
    GET_DONATE_CODE_LIST: '/Service/GetDonateCodeList',
    GET_THEME_PRODUCT_LIST: '/Product/GetThemeProductList',
    GET_PRODUCT_THEME_LIST: '/Product/GetProductThemeListByType',
    GET_HOME_PRODUCT_LIST: '/Product/GetHomeProductList',
    GET_HOME_LATEST_NEWS: '/Home/GetLatestNews',
    GET_CATALOG_LIST: '/Catalog/GetCatalogList',
    GET_PRODUCT_CATEGORY_THEMES: '/ProductCategory/GetProductTheme',
    GET_PRODUCT_CATEGORY_OVERVIEW: '/ProductCategory/GetProductsOverview',
    GET_PRODUCT_MAIN_CLASS_TREE:
        '/product/get-product-main-class-tree-by-super-class-id',
    GET_PRODUCT_MAIN_CLASS_DETAIL: '/Product/GetProductListByMainClassId',
    GET_PRODUCT_POSTPROCESSING_DETAIL:
        '/product/get-postprocessing-product-list-by-main-class-id',
    ADD_REPORT_HISTORY: '/Product/AddPrintProductListToReporthistory',
    ADD_PRODUCT_FAVORITE: '/Product/AddProductFavorite',
    UPD_PRODUCT_FAVORITES: '/Product/UpdProductFavorites',
    GET_PRODUCT_FAVORITES: '/Product/GetProductFavorites',
    GET_PRODUCT_INFO_BY_PRODUCT_CLASS_ID:
        '/Product/GetProductInfoByProductClassId',
    PRODUCT_SEARCH: '/CoEdition/Product/ProductSearch',
    CO_EDITION_GET_MAIN_CLASS: '/CoEdition/Product/CoEditionGetMainClass',
    CO_EDITION_GET_PRODUCT_SUB_MAIN_CLASS:
        '/CoEdition/Product/CoEditionGetProductSubMainClass',
    CO_EDITION_GET_PRODUCT_CLASS_WITH_PRICE:
        '/CoEdition/Product/CoEditionGetProductClassWithPrice',
    SEARCH_PRODUCT_WITH_PRICE_V2: '/CoEdition/Product/SearchProductWithPriceV2',
    CO_EDITION_GET_PRODUCT_AND_OPTION:
        '/CoEdition/Product/CoEditionGetProductAndOption',
    CO_EDITION_GET_PRODUCT_PRICE_LIST:
        '/CoEdition/Product/CoEditionGetProductPriceList',
    GET_PRODUCT_PRICE_REPORT: '/CoEdition/Product/GetProductPriceReport',
    CHECK_COMPANY_NUMBER: '/Account/CheckCompanyNumber',
    CHECK_COMPANY_NUMBER_NON_EXIST_GAINHOW_COMPANY_NUMBER:
        '/Account/CheckCompanyNumberNonExistGainHowCompanyNumber',
    ADD_PORTFOLIO: '/Order/AddPortfolio',
    GET_PORTFOLIO_BY_BOOK_ID: '/Order/GetPortfolioByBookId',
    ADD_RGB_ORDER: '/Order/AddRgbOrder',
    GET_RGB_ORDER: '/Order/GetRgbOrderResult',
    GET_GALLERY_CATEGORY_PAGE: '/Gallery/GetGalleryCategoryPage',
    GET_GALLERY_PRODUCT_DETAIL: '/Gallery/GetGalleryProductDetail',
    CHECK_SHARE_BOOK_STATUS: '/Portfolio/CheckShareBookStatus',
    DO_SHARE: '/Portfolio/DoShare',
    UPLOAD_USER_FILE: '/Scripts/plupload/UploadHandler.ashx',
};

/**
 * Mall API 常數
 */
export const API_MALL: ApiMallConfig = {
    GET_PRODUCT_INFO: '/commodities/cmdy-id/queries',
    GET_PRODUCT_INFO_MAPPING_CODE: '/commodities/mapping-code/queries',
    GET_CLOUD_PRINT_CALC_PRICE: '/commodities/get-rgb-cmdy-price-for-app',
    GET_TEMPLATE_CLASS: '/editors/template-classes/queries',
    GET_TEMPLATE_LIST: '/editors/templates/queries',
};
